module.exports = __webpack_public_path__ + "img/bg-ppt-0.c9c51830.png";